import React from 'react';
import './App.css';
// import Home from "./Pages/Home";
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './Pages/Login';
// import NoMatch from "./Pages/NoMatch";
import Course from './Pages/Courses';
import Reports from './Pages/Reports';
import UploadCourse from './Pages/UploadCourse';
import EditCourses from './Pages/EditCourses';
import UpdateCourse from './Pages/UpdateCourse';
import CourseMaping from './Pages/CourseMaping';
import CourseDetails from './Pages/CourseDetails';
import { AuthProvider } from './hooks/authProvider';
import Questionnaire from './Pages/Questionnaire';
import PrivateRoute from './Component/privateRoute';
import CongratulationScreen from './Pages/Congratulation';
import { Provider } from 'react-redux';
import { store } from './store';
import Training from './Pages/Training';
import Batch from './Pages/Batch';
import BatchTasks from './Pages/BatchTasks';
import Attendence from './Pages/Attendence';
import MarkAttendance from './Pages/Attendence/MarkAttendance';
import ViewStats from './Pages/Attendence/ViewStats';
import FeedbackForm from './Pages/Attendence/FeedbackForm';
import BranchInfo from './Pages/Attendence/BranchInfo';
import AllTrainings from './Pages/Training/AllTrainings';
import CreateBatch from './Pages/Training/CreateBatch';
import ClusterView from './Pages/Training/ClusterView';
import RegionsCircles from './Pages/Training/RegionsCircles';
import Trainers from './Pages/Training/Trainers';
import ExternalLinks from 'Pages/ExternalLinks';
import TrainingTypes from './Pages/Training/TrainingTypes';
import TrainingReports from 'Pages/Training/TrainingReports';
import ScheduleTraining from 'Pages/ScheduleTraining';
import Declaration from 'Pages/Declaration';
import ViewDeclaration from 'Pages/ViewEmpDeclaration';
import TraineeApproval from 'Pages/Training/TraineeApproval';
import BatchApproval from 'Pages/Training/BatchApproval';
import BatchApprovalCL from 'Pages/Training/BatchApprovalCL';
import SFLPolicies from 'Pages/SFLPolicies';
import SFLDashboards from 'Pages/SFLDashboards';
import Unauthorized from 'Pages/Unauthorized';
import CertificationLogs from 'Pages/Training/CertificationLogs';
import EmployeeData from 'Pages/EmployeeData';
import Dashboard from 'Pages/Dashboard';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FeedbackModalWrapper from 'Component/FeedbackModal/FeedbackModalWrapper';
// Component/FeedbackModalWrapper
import { ThemeProvider } from './contexts/ThemeContext';
import { initializeSecurity } from './utils/securityUtils';
import { initializeUrlTracking } from './utils/sessionUtils';
import './utils/devTest'; // Import development tests
import './utils/verifySecurity'; // Import security verification
import CorrectiveBranches from 'Pages/Training/CorrectiveBranches';
import TrainingConfiguration from 'Pages/Training/TrainingConfiguration';
import PFApproval from 'Pages/Training/PFApproval';
import DYKSection from 'Pages/DYK';
import WinnerShipping from 'Pages/DYK/WinnerShipping';
import ClusterConfig from 'Pages/Training/ClusterConfig';
import LanguageConfig from 'Pages/LanguageConfig';
import TasksList from 'Pages/Tasks';
import CreateTask from 'Pages/Tasks/CreateTask';
import TaskDetail from 'Pages/Tasks/TaskDetail';
import MyAssignments from 'Pages/Tasks/MyAssignments';
import AssignmentDetail from 'Pages/Tasks/AssignmentDetail';
import { AssignmentsProvider } from './contexts/AssignmentsContext';

const App = () => {
  // Initialize security measures and URL tracking
  React.useEffect(() => {
    initializeSecurity();
    initializeUrlTracking();
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider>
        <ToastContainer />
        <Router>
          <AuthProvider>
            <AssignmentsProvider>
              <FeedbackModalWrapper />
              <Routes>
                <Route element={<PrivateRoute />}>
                  <Route path="/" element={<Course />} />
                  <Route path="/courses" element={<Course />} />
                  <Route
                    path="/courses/:id/:uniqueCourseKeyInEmployeeCourses/:status/"
                    element={<CourseDetails />}
                  />
                  <Route
                    path="/questionnaire/:id/:uniqueCourseKeyInEmployeeCourses"
                    element={<Questionnaire />}
                  />
                  <Route path="/reports" element={<Reports />} />
                  <Route path="/upload-course" element={<UploadCourse />} />
                  <Route path="/update-course/:id" element={<UpdateCourse />} />
                  <Route path="/edit-courses" element={<EditCourses />} />
                  <Route path="/courses-mapping" element={<CourseMaping />} />
                  <Route
                    path="/congratulation/:id/:uniqueCourseKeyInEmployeeCourses"
                    element={<CongratulationScreen />}
                  />
                  <Route path="/training/AllTrainings" element={<AllTrainings />} />
                  <Route path="/training/create-batch" element={<CreateBatch />} />
                  <Route path="/training/cluster-view" element={<ClusterView />} />
                  <Route path="/training/cluster-config" element={<ClusterConfig />} />
                  <Route path="/training/regions-circles" element={<RegionsCircles />} />
                  <Route path="/training/certification-logs" element={<CertificationLogs />} />
                  <Route path="/training/training-reports" element={<TrainingReports />} />
                  <Route path="/training/corrective-branches" element={<CorrectiveBranches />} />
                  <Route
                    path="/training/training-configuration"
                    element={<TrainingConfiguration />}
                  />
                  <Route path="/training" element={<Training />} />
                  <Route path="/training/:id" element={<Training />} />
                  <Route path="/batch/:id" element={<Batch />} />
                  <Route path="/batch/attendence/" element={<Attendence />} />
                  <Route path="/attendance" element={<Attendence />} />
                  <Route path="/attendance/mark" element={<MarkAttendance />} />
                  <Route path="/attendance/stats" element={<ViewStats />} />
                  <Route path="/attendance/feedback" element={<FeedbackForm />} />
                  <Route path="/attendance/branch-info" element={<BranchInfo />} />
                  <Route path="/batch-tasks" element={<BatchTasks />} />
                  <Route path="/training/Trainers" element={<Trainers />} />
                  <Route path="/external-learning-portal" element={<ExternalLinks />} />
                  <Route path="/training/training-types" element={<TrainingTypes />} />
                  <Route path="/training-calendar" element={<ScheduleTraining />} />
                  <Route path="/declaration-section" element={<Declaration />} />
                  <Route path="/view-emp-declaration" element={<ViewDeclaration />} />
                  <Route path="/sfl-policies" element={<SFLPolicies />} />
                  <Route path="/sfl-dashboards" element={<SFLDashboards />} />
                  <Route path="/trainee-approval/:id" element={<TraineeApproval />} />
                  <Route path="/batch-approval/:id" element={<BatchApproval />} />
                  <Route path="/batch-approval-cl/:id" element={<BatchApprovalCL />} />
                  <Route path="/pf-approval/:batchId/:step" element={<PFApproval />} />
                  <Route path="/employee-data" element={<EmployeeData />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/dyk-section" element={<DYKSection />} />
                  <Route path="/task/language-config" element={<LanguageConfig />} />
                  <Route path="/tasks" element={<TasksList />} />
                  <Route path="/tasks/create" element={<CreateTask />} />
                  <Route path="/tasks/:taskId" element={<TaskDetail />} />
                  <Route path="/my-assignments" element={<MyAssignments />} />
                  <Route path="/my-assignment/:taskType/:taskId" element={<AssignmentDetail />} />
                  <Route path="/unauthorized" element={<Unauthorized />} />
                  <Route path="/dyk-winner-shipping" element={<WinnerShipping />} />
                </Route>
                <Route path="/login" element={<Login />} />
                {/* <Route path="*" element={<NoMatch />} /> */}
              </Routes>
            </AssignmentsProvider>
          </AuthProvider>
        </Router>
      </ThemeProvider>
    </Provider>
  );
};

export default App;
